import ProblemDetailsException from "../exceptions/ProblemDetailsException";

/**
 * Fetch client middleware to handle requests to api
 * 
 * @param {string} url - valid url, ex. https://loomissc.dev.local/api/loomis/news
 * @param {RequestInit} options - valid fetch options
 * @returns {Object} response from api
 */
export default async (url, options = {}) => {
  try {
    const response = await fetch(url, options);

    if (!response) {
      throw new Error("Response is not defined");
    }
    if (!response.status) {
      throw new Error("Response status is not defined");
    }

    const data = await response.json();

    if (response.status !== 200) {
      throw new ProblemDetailsException(data);
    }
    if (response.status === 200) {
      return {
        success: true,
        data,
      };
    }

    return {
      success: false,
      data: null,
    };
  } catch (error) {
    console.error(error);
    if (error instanceof ProblemDetailsException && error.invalidProperties) {
      const invalidProperties = error.invalidProperties;
      const errors = Object.keys(invalidProperties).map((key) =>
        Array.isArray(invalidProperties[key])
          ? invalidProperties[key].join(" | ")
          : invalidProperties[key]
      );
      return {
        success: false,
        data: null,
        errors,
      };
    } else {
      return {
        success: false,
        data: null,
      };
    }
  }
};
